import WaffleFlag from './flags'
import WaffleSwitch from './switches'

// Type for the underlying WaffleJS module, not this module.
// Exported for testing purposes.
export type WaffleJS = {
  flag_is_active: (flag: WaffleFlag) => boolean
  switch_is_active: (waffleSwitch: WaffleSwitch) => boolean
}

declare global {
  interface Window {
    waffle?: WaffleJS
  }
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function flag_is_active(flag: WaffleFlag): boolean {
  // ensure if for some reason waffle isn't on our window, we don't blow up.
  // just treat all flags as disabled.
  if (!window.waffle) return false

  return window.waffle.flag_is_active(flag)
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function switch_is_active(waffleSwitch: WaffleSwitch): boolean {
  // ensure if for some reason waffle isn't on our window, we don't blow up.
  // just treat all switches as disabled.
  if (!window.waffle) return false

  return window.waffle.switch_is_active(waffleSwitch)
}
